import { createGlobalStyle } from "styled-components";
import theme from "./theme";

// const fontStyle = css`
//   @font-face {
//     font-family: "Roboto";
//     font-style: normal;
//     font-weight: 100;
//     font-display: swap;
//     src: url("./assets/fonts/Roboto-Thin.woff") format("woff");
//   }
//   @font-face {
//     font-family: "Roboto";
//     font-style: normal;
//     font-weight: 300;
//     font-display: swap;
//     src: url("./assets/fonts/Roboto-Light.woff") format("woff");
//   }
//   @font-face {
//     font-family: "Roboto";
//     font-style: normal;
//     font-weight: 400;
//     font-display: swap;
//     src: url("./assets/fonts/Roboto-Regular.woff") format("woff");
//   }
//   @font-face {
//     font-family: "Roboto";
//     font-style: normal;
//     font-weight: 500;
//     font-display: swap;
//     src: url("./assets/fonts/Roboto-Medium.woff") format("woff");
//   }
//   @font-face {
//     font-family: "Roboto";
//     font-style: normal;
//     font-weight: 700;
//     font-display: swap;
//     src: url("./assets/fonts/Roboto-Bold.woff") format("woff");
//   }
// `;

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, menu, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  main, menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, main, menu, nav, section {
    display: block;
  }

  /* HTML5 hidden-attribute fix for newer browsers */
  *[hidden] {
    display: none;
  }

  body {
    line-height: 1;
    /* min-height: 100vh;
    min-height: -webkit-fill-available;  */
  }

  html, body {
			height: 100%;
	}
  
  menu, ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    text-decoration: none;
  }
  
  * {
      box-sizing : border-box;
      font-family: 'Noto Sans', sans-serif;
  }
  body {
    background-color : ${theme.color.neutral_200};
  }
  .noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

  input:focus {
    /* outline : none; */
  }
  input {
    &::placeholder {
      color : ${theme.color.neutral_300};
    }
  }

  // edge - input(password)일때 보여지는 hide/show 버튼 지우기
  input::-ms-reveal, input::-ms-clear {
    display: none;
  }

  select {
  /* -webkit-appearance: none;
  -moz-appearance: none; */
  text-indent: 1px;
  text-overflow: '';
  /* outline : none; */
}


.react-datepicker__current-month{
  display: none;
}

.react-datepicker__month-select {
  border : none;
  background : transparent;
  font-weight : 700;
  font-size: 17px;
  line-height: 20px;
} 
.react-datepicker__year-select {
  display : block !important;
  border : none;
  background : transparent;
  font-weight : 700;
  font-size: 17px;
  line-height: 20px;
  margin-right : 3px;
}

.react-datepicker__header__dropdown {
  display : flex;
  flex-direction : row-reverse;
  justify-content : center;
  gap : 15px;
  position : relative;
  
}

/* 한국어(locale=ko)일 때만 연도 단위 텍스트 표시 */
html[lang="ko"] .react-datepicker__header__dropdown::after {
  display : block;
  content : var(--year-unit);
  font-weight : 700;
  position : absolute;
  font-size : 17px;
  top : 1px;
}
em {
  font-style : italic;
}
h1 {
  font-size : 40px;
}
h2 {
  font-size : 30px;
}
h3 {
  font-size : 25px;
}
button {
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  line-height: 1;
  cursor: pointer;
}
button:focus {
  /* outline:none; */
}
&::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 10px;
}
&::-webkit-scrollbar-thumb {
  height: 30%;
  background: ${theme.statusColor.SCROLLBAR};
  border-radius: 10px;
}
&::-webkit-scrollbar-track {
  background: rgba(0,0,0,0);
  border-radius: 10px;
}

  // theme screen size md
  @media (max-width: 768px) {
   *{
    letter-spacing: -0.24px;
  }
    scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  }
`;

export default GlobalStyle;
